const currentReqTypes = {
  FETCH_CURRENTREQ_START: "FETCH_CURRENTREQ_START",
  FETCH_CURRENTREQ_SUCCESS: "FETCH_CURRENTREQ_SUCCESS",

  FETCH_CURRENTREQBITS_START: "FETCH_CURRENTREQBITS_START",
  FETCH_CURRENTREQBITS_SUCCESS: "FETCH_CURRENTREQBITS_SUCCESS",

  FETCH_LOADLOACTION_START: "FETCH_LOADLOACTION_START",
  FETCH_LOADLOCATION_SUCCESS: "FETCH_LOADLOCATION_SUCCESS",

  FETCH_CURRENTREQCANCEL_START: "FETCH_CURRENTREQCANCEL_START",
  FETCH_CURRENTREQCANCEL_SUCCESS: "FETCH_CURRENTREQCANCEL_SUCCESS",

  CLEAR_CURRENTREQ: "CLEAR_CURRENTREQ",
};

export default currentReqTypes;
